export default __webpack_public_path__ + "static/own_portal-66d8c1955a9e62c6089ac67f93a5abbb.svg";